import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Modal, Button } from 'antd';
import UploadSuccess from '~client/pages/dashboard/reconciliation/bulk-update/upload-success';
import Loading from '~pages/dashboard/reconciliation/bulk-update/loading';
import File from '~pages/dashboard/reconciliation/bulk-update/file';
import UploadExcel from '~pages/dashboard/reconciliation/bulk-update/upload-excel';
import useBulkUpdate from './useBulkUpdate';

const BulkUpdate = ({ onClose, onSuccess }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const { handleClickConfirmUpload, isLoading, isUploadSuccess } = useBulkUpdate({
    selectedFile,
    onSuccess,
  });

  const handleClickCheckBulkHistory = useCallback(() => {
    onSuccess();
  }, []);

  const uploadFileFooter = [
    <Button key="back" onClick={onClose}>
      {i18next.t('cms.reconciliation.booking.cancel_bulk.button')}
    </Button>,
    <Button key="submit" type="primary" onClick={handleClickConfirmUpload} disabled={!selectedFile}>
      {i18next.t('Next')}
    </Button>,
  ];

  const uploadLoadingFooter = [
    <Button key="gotIt" type="primary" onClick={onClose} disabled={isLoading}>
      {i18next.t('cms.reconciliation.booking.bulk_update_modal.got_it.btn')}
    </Button>,
  ];

  const uploadSuccessFooter = [
    <Button key="checkBulkHistory" onClick={handleClickCheckBulkHistory}>
      {i18next.t('cms.reconciliation.booking.button.check_bulk_history')}
    </Button>,
    <Button key="gotIt" type="primary" onClick={onClose}>
      {i18next.t('cms.reconciliation.booking.bulk_update_modal.got_it.btn')}
    </Button>,
  ];

  const getFooter = useCallback(() => {
    if (isLoading) {
      return uploadLoadingFooter;
    }
    if (isUploadSuccess) {
      return uploadSuccessFooter;
    }

    return uploadFileFooter;
  }, [isLoading, isUploadSuccess, selectedFile]);

  return (
    <Modal
      width={454}
      maskClosable={false}
      centered
      zIndex={99}
      visible
      onCancel={onClose}
      className="bulk-update-modal"
      footer={getFooter()}
    >
      <Choose>
        <When condition={isUploadSuccess}>
          <UploadSuccess />
        </When>
        <Otherwise>
          <div className="bulk-update-modal__title">{i18next.t('Upload Record')}</div>
          <Form layout="vertical">
            <Form.Item label={i18next.t('Record Upload')}>
              <Choose>
                <When condition={isLoading}>
                  <Loading />
                </When>
                <When condition={selectedFile}>
                  <File selectedFile={selectedFile} setSelectedFile={setSelectedFile} />
                </When>
                <Otherwise>
                  <UploadExcel setSelectedFile={setSelectedFile} />
                </Otherwise>
              </Choose>
            </Form.Item>
          </Form>
        </Otherwise>
      </Choose>
    </Modal>
  );
};

BulkUpdate.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
};

BulkUpdate.defaultProps = {
  onClose: () => {},
  onSuccess: () => {},
};

export default Form.create({ name: 'bulk-update' })(BulkUpdate);
